/* eslint-disable max-len */
import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import TimeStop from '../../Elements/TimeStop';
import { STEP_TYPE } from '../../../constants';
import pluralize from 'pluralize';

const StepPopup = ({ step, setStepsHovered, stepPopover }) => {
  return (
    <div className="step-popup">
      <a className="btn-close" onClick={() => setStepsHovered({ [stepPopover]: false })}>
        <CloseOutlined />
      </a>
      <div className="header">
        <div className="left">
          {step.type === STEP_TYPE.delivery
            ? step.orderCode
            : `${step.orderIds.length || 0} ${pluralize('package', step.orderIds.length || 0)}`}
        </div>
        <TimeStop step={step} />
      </div>
      <p>
        <strong>
          [{step.type.toLowerCase() === 'pickup' ? 'Pickup' : 'Delivery'}] {step.name}
        </strong>
      </p>
      <p>{step.address}</p>
      <div className="actions">
        {/* {canEdit && !['failed', 'skipped', 'completed'].includes(stop && stop.status) && (
          <a onClick={() => moveToUnscheduled(route, indexSteps)}>
            Move to Unscheduled
            <Icon
              component={MoveToInbox}
              style={{
                width: 14,
                marginLeft: 5,
              }}
            />
          </a>
        )} */}
        {/* <a
          // onClick={() => onClickStep(step.orderId, step.type.toLowerCase() === 'pickup' ? 'delivery' : 'pickup')}
          style={{
            marginLeft: 20,
          }}
        >
          Go to {step.type.toLowerCase() === 'pickup' ? 'Delivery' : 'Pickup'}
          <Icon
            component={ArrowRight}
            style={{
              width: 10,
              marginLeft: 5,
            }}
          />
        </a> */}
      </div>
    </div>
  );
};

export default StepPopup;

// const MoveToInbox = () => (
//   <svg viewBox="0 0 24 24" fill="currentColor">
//     <path d="M0 0h24v24H0V0z" fill="none" />
//     <path d="M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z" />
//   </svg>
// );

// const ArrowRight = () => (
//   <svg viewBox="0 0 448 512">
//     <path
//       fill="currentColor"
//       d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"
//       className=""
//     ></path>
//   </svg>
// );
